document.addEventListener('DOMContentLoaded', function () {
  const navItems = document.querySelectorAll('nav[role="navigation"] > ul > li');

  navItems.forEach(function (item) {
    let leaveTimer;

    item.addEventListener('mouseenter', function () {
      clearTimeout(leaveTimer);
      const btn = item.querySelector('button');
      const isOpen = item.querySelector('[aria-expanded="true"]');
      if (btn && !isOpen) btn.click();
    });

    item.addEventListener('mouseleave', function () {
      leaveTimer = setTimeout(function () {
        const btn = item.querySelector('button');
        const isOpen = item.querySelector('[aria-expanded="true"]');
        if (btn && isOpen) btn.click();
      }, 300);
    });
  });
});
